export default __webpack_public_path__ + "static/media/planetsoft-login.2f22f51c.png";